<template>
  <BaseWorkPageLayout :title="$t('global.events')" icon="clock">
    <template #cta>
      <BaseButton
        v-if="editionMode"
        icon="paper-plane"
        :title="$t('button.save')"
        @click="submitForm"
      />
      <BaseButton
        v-if="
          this.$route.name !== 'settings_create_user' &&
          this.$can('manage_content')
        "
        color="warning"
        :icon="editionMode ? 'times' : 'pen'"
        @click="switchEditMode"
        :title="editionMode ? $t('button.cancel') : $t('button.edit')"
      />
    </template>
    <template #default>
      <div class="flex flex-col gap-4">
        <div v-for="(event, index) in cEvents" :key="eventKey(event)">
          <WorkEvent
            :propsEvent="event"
            :metadata="metadata"
            :index="index"
            :errors="
              errors.events && errors.events.length ? errors.events[index] : {}
            "
            :editionMode="editionMode"
            @eventDeleteButtonPressed="deleteEvent"
          />
        </div>
        <div v-if="editionMode" class="flex flex-row justify-end">
          <div class="flex-1">
            <BaseButton
              icon="plus"
              color="dark"
              :title="$t('global.add_event')"
              @click="addEvent"
            />
          </div>
          <!--          <div>-->
          <!--            -->
          <!--          </div>-->
        </div>
      </div>
    </template>
  </BaseWorkPageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkEvent from '@p/works/form/subpages/events/WorkEvent'

// A stable key per event, unsaved ones included: deleting one (splice) must
// not hand its form to the next event.
const eventKeys = new WeakMap()
let nextEventKey = 0

export default {
  name: 'TheWorkFormEventsPage',
  components: {
    WorkEvent
  },
  data() {
    return {
      editionMode: false
    }
  },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      errors: 'auth/getErrors',
      metadata: 'work/getWorkMetadata'
    }),
    cEvents() {
      let sorted_events = this.work.events
      return sorted_events
    }
  },
  methods: {
    ...mapActions({
      updateWork: 'work/updateWork',
      fetchWorkById: 'work/fetchWorkByID'
    }),
    // A 422 is toasted by apiClient, with the rejected fields.
    submitForm() {
      return this.updateWork({
        form_data: {
          id: this.$route.params.id,
          work: this.work
        }
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.updated_m', { var: this.$t('attributes.work') })
        )
        this.editionMode = false
      })
    },
    eventKey(event) {
      if (event.id) return event.id
      if (!eventKeys.has(event)) eventKeys.set(event, `new-${nextEventKey++}`)
      return eventKeys.get(event)
    },
    addEvent() {
      this.work.events.push({})
    },
    deleteEvent(id) {
      this.work.events.splice(id, 1)
    },
    switchEditMode() {
      if (this.editionMode) {
        this.fetchWorkById(this.$route.params.id)
      }
      this.editionMode = !this.editionMode
    }
  }
}
</script>

<style scoped></style>
